import styled, { createGlobalStyle, css } from "styled-components";

import { varColor } from "@formant/ui/utils/themeHelpers";

const GlobalStyles = css`
    :root {
        --formant-color-dark: ${varColor("primary", "dark")};
        --formant-color-app: ${varColor("primary", "module")};
        --formant-color-background: ${varColor("primary", "flagship")};
        --formant-color-module-header: ${varColor("primary", "flagship")};
        --formant-color-module-content: ${varColor("primary", "module")};
        --formant-color-primary-1: ${varColor("primary", "steel01")};
        --formant-color-primary-2: ${varColor("primary", "steel02")};
        --formant-color-primary-3: ${varColor("primary", "steel03")};
        --formant-color-foreground-1: ${varColor("primary", "white")};
        --formant-color-foreground-2: ${varColor("primary", "silver")};
    }

    #root {
        display: flex;
        flex: 1;
    }

    a {
        transition: color 200ms ease-in-out 0ms;
        color: inherit;
        text-decoration: none;
    }

    :focus {
        outline: none;
    }

    ::-webkit-scrollbar {
        background: transparent;
        width: 0.5rem;
        height: 0.5rem;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 0.25rem;
        background: var(--formant-color-primary-silver);
        &:hover {
            background: var(--formant-color-primary-silver);
        }
    }

    ::-webkit-scrollbar-corner {
        background: var(--formant-color-primary-silver);
    }
`;

export const FormantStyles = createGlobalStyle`
  ${GlobalStyles}
`;

export const StyledTypographyCore = styled.div`
    background: var(--formant-color-app);
    font-family: Moderat, sans-serif;
    font-variant-numeric: tabular-nums;
    font-size: 1rem;
    letter-spacing: 0.05em;
    color: var(--formant-color-primary-white);
    -webkit-font-smoothing: antialiased;
`;

export const StyledApp = styled(StyledTypographyCore)`
    display: flex;
    overscroll-behavior: none;

    flex: 1;
    margin: 0;

    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
`;

export const StyledPageAndBanner = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
`;

export const AppPage = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const ListeningText = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;
